import { render, staticRenderFns } from "./helpDialog.vue?vue&type=template&id=5c39cb2a"
import script from "./helpDialog.vue?vue&type=script&lang=js"
export * from "./helpDialog.vue?vue&type=script&lang=js"
import style0 from "./helpDialog.vue?vue&type=style&index=0&id=5c39cb2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports